var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDotsdashnew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3915 12.8715C12.9989 12.8715 13.4913 12.3791 13.4913 11.7717C13.4913 11.1643 12.9989 10.6719 12.3915 10.6719C11.784 10.6719 11.2916 11.1643 11.2916 11.7717C11.2916 12.3791 11.784 12.8715 12.3915 12.8715Z",
    fill: "#242E2C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3915 7.00435C12.9989 7.00435 13.4913 6.51194 13.4913 5.90452C13.4913 5.2971 12.9989 4.80469 12.3915 4.80469C11.784 4.80469 11.2916 5.2971 11.2916 5.90452C11.2916 6.51194 11.784 7.00435 12.3915 7.00435Z",
    fill: "#242E2C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3915 18.7387C12.9989 18.7387 13.4913 18.2463 13.4913 17.6389C13.4913 17.0315 12.9989 16.5391 12.3915 16.5391C11.784 16.5391 11.2916 17.0315 11.2916 17.6389C11.2916 18.2463 11.784 18.7387 12.3915 18.7387Z",
    fill: "#242E2C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDotsdashnew);
export default __webpack_public_path__ + "static/media/dotsdashnew.dc14d86f488389425899b3677fecbd1e.svg";
export { ForwardRef as ReactComponent };